export default {"src":"/_next/static/media/extra-work.5265d495.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};